export const SUPPORTED_BROWSERS = {
  android: {
    chrome: '117',
    firefox: '133',
    edge: '133',
    samsung: '25',
  },
  ios: {
    chrome: '92',
    safari: '15',
  },
  osx: {
    chrome: '86',
    firefox: '81',
    edge: '86',
    opera: '72',
    safari: '16',
  },
  windows: {
    chrome: '86',
    firefox: '81',
    edge: '86',
    opera: '72',
    safari: '16',
  },
  linux: {
    firefox: '102',
    chrome: '122',
  },
};
